import { REPORTSUMMARYNEW_SUCCESS, REPORTSUMMARYNEW_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const reportSummaryNewReducer = (state = initialState, action) => {
    switch (action.type) {
        case REPORTSUMMARYNEW_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case REPORTSUMMARYNEW_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default reportSummaryNewReducer;
